<template>
  <v-app id="login" class="primary">
    <v-container fluid fill-height class="pa-0">
      <!--<v-layout align-center justify-center>-->
      <v-layout row wrap>
        <v-flex sm6 md8 lg8>
          <div id="divider"></div>
        </v-flex>
        <v-flex xs12 sm6 md4 lg4>
          <div class="pt-5 pl-4">
            <h3>Alterar Senha</h3>
          </div>
          <v-card class="elevation-0 pa-3" flat>
            <v-card-text>
              <v-form ref="form">
                <v-text-field
                  append-icon="person"
                  name="email"
                  label="Email"
                  type="text"
                  v-model="model.email"
                  v-validate="'required|email'"
                  :v-errors="errors"
                  :error-messages="errors.collect('email')"
                  data-vv-name="email"
                  required
                  outline
                  v-on:keyup.13="login"
                  disabled
                >
                </v-text-field>
                <v-text-field
                  append-icon="lock"
                  name="password"
                  label="Senha"
                  type="password"
                  v-model="model.password"
                  data-vv-name="senha"
                  v-validate="'required|min:6'"
                  v-on:keyup.13="resetPassword"
                  :v-errors="errors"
                  :error-messages="errors.collect('senha')"
                  required
                >
                </v-text-field>
                <v-text-field
                  append-icon="lock"
                  name="password_confirmation"
                  label="Confirmação"
                  id="password_confirmation"
                  type="password"
                  v-model="model.password_confirmation"
                  data-vv-name="senha"
                  v-validate="'required'"
                  v-on:keyup.13="resetPassword"
                  :v-errors="errors"
                  required
                >
                </v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn text small :to="{ name: 'login' }">Entrar</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                dark
                color="indigo"
                @click="resetPassword"
                :loading="logging"
                >Alterar Senha</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { checkRemeberToken, resetPassword } from "../../services/auth.service";

export default {
  data: () => ({
    logging: false,
    model: {
      email: "",
      token: "",
      password: "",
      password_confirmation: "",
    },
    rememberToken: "",
    validToken: false,
  }),
  mounted() {
    this.model.email = this.$route.params.email;
    this.model.token = this.$route.params.token;
  },
  methods: {
    async resetPassword() {
      if (await this.formHasErrors()) return;
      this.logging = true;
      resetPassword(this.model)
        .then((response) => {
          this.logging = false;
          // console.log(response)
          this.$router.push({ name: "login" });
          window.getApp.sendSnackMessage(response.data.status);
        })
        .catch((ex) => {
          this.logging = false;
          // console.log(ex.response)
          window.getApp.sendSnackMessage(ex.message, "error");
        });
    },
  },
};
</script>
<style scoped lang="css">
#login {
  height: 0%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}

#divider {
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
  background-image: url("/img/login/lucas-muita-aprovacao.jpg");
  background-size: cover;
  overflow: hidden;
}
</style>
